import React from 'react'
import { Row, Col } from "react-bootstrap"
import PropTypes from 'prop-types';
import { FontSizes } from '@fluentui/react';

function RolesCard(props) {
    //Parametros de entrada.
    const {
        inputParam_ElementItem = null,
    } = props;

    const circleStyle = {
        width: "55px",
        height: "55px",
        backgroundColor: "grey",
        borderRadius: '50%',
        padding: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        FontSizes: '12px'
    };

    return (
        <>
            <Row className='py-1 border-bottom' style={{borderBottom: "2px solid #c8c3c3 !important"}}>
                <Col className='col-auto'>
                    <div style={circleStyle}>
                        <div style={{ fontWeight: "bold", color: "white" }}>
                            { inputParam_ElementItem.rol }
                        </div>
                    </div>
                </Col>
                <Col className='my-auto'>
                    {
                        inputParam_ElementItem.usernames !== undefined &&
                        <Row>
                            {
                                inputParam_ElementItem.usernames.split(',').map((x, index) => (
                                    <Col xl={12} className={index !== 0 ? "border-top" : ""}>{x}</Col>
                                ))
                            }
                        </Row>
                    }
                    {
                        inputParam_ElementItem.usernames === undefined &&
                        inputParam_ElementItem.nRoles
                    }
                </Col>
            </Row>
        </>
    );
}

///Proptypes
RolesCard.propTypes = {
    inputParam_ElementItem: PropTypes.object.isRequired,
};

export default RolesCard;